import { TextFontFamilies, } from "../types/text";
export const TEXT_DEFINITIONS = {
    h: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 64,
    },
    h1: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 52,
    },
    h2: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 42,
    },
    h3: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 32,
    },
    h4: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 28,
    },
    h5: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 24,
    },
    h6: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 20,
    },
    title1: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 18,
    },
    title2: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 16,
    },
    title3: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 14,
    },
    title4: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 12,
    },
    body: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 24,
    },
    body1: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 18,
    },
    body2: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 16,
    },
    body3: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 14,
    },
    body4: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 12,
    },
    button: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 14,
    },
    textFieldLabel: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 14,
    },
    textFieldBody: {
        fontFamily: TextFontFamilies.neuelKabel,
        fontSize: 16,
    },
};
export const TEXT_OPTIONS_DEFINITIONS = {
    fontFamily: TextFontFamilies.neuelKabel,
    fontWeightRegular: 500,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
    maxMobileFontSize: 32,
};
export const DISABLED_MUI_TEXT_DEFINITIONS = {
    caption: undefined,
    overline: undefined,
    subtitle1: undefined,
    subtitle2: undefined,
};
//# sourceMappingURL=text.js.map